import Question from "models/question";
import { QuestionnaireComponentTranslations } from "translations/types";

export default function isEngageCodeValid(code: string | undefined): boolean {
    if (!code) return false;

    const engageCodePattern = /^[Mm]\d{4}$/;

    return engageCodePattern.test(code);
}

export function extractEngageCodeError(
    question: Question,
    previousQuestion: Question | undefined,
    translations: { questionnaireComponent: QuestionnaireComponentTranslations }
): string | undefined {
    if (
        question.key === "engageCode" &&
        previousQuestion?.answer.rawValue === "yes" &&
        !isEngageCodeValid(question.answer.rawValue)
    ) {
        return translations.questionnaireComponent.invalidEngageCodeFormat;
    }
    return undefined;
}
